// slice 02.1 · paso b.6b — menú flotante "+" del canvas de roadmap (`ComponentTaskFlow.jsx`).
// Dueño de `FLOW_MENU_ITEMS` (antes recreado en cada render del container). Presentacional puro:
// solo `onAddNode(category, item)`, sin fetch ni estado propio.

const FLOW_MENU_ITEMS = {
    trigger: [],
    etapa: [
        { id: 'etapa-simple', label: 'Etapa simple', icon: '🤝', sub: 'etapa-negociacion' }
    ],
    texto: [
        { id: 'texto-simple', label: 'Texto simple', icon: 'T', sub: 'texto-simple' },
        { id: 'texto-inverso', label: 'Texto escala inversa', icon: 'T', sub: 'texto-inverso' },
        { id: 'post-it', label: 'Post-it', icon: '📝', sub: 'post-it' },
        { id: 'texto-enriquecido', label: 'Texto enriquecido', icon: '🔗', sub: 'texto-enriquecido' }
    ],
    formas: [
        { id: 'linea', label: 'Línea', icon: '〰️', sub: 'linea' }
    ]
};

export default function FlowAddNodeMenu({ visible, onAddNode }) {
    if (!visible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '50px',
            right: '3px',
            width: '160px',
            background: 'rgba(15, 15, 20, 0.95)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            zIndex: 100,
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)'
        }}>
            <div>
                <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#888', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Triggers</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {FLOW_MENU_ITEMS.trigger.map(item => (
                        <button key={item.id} onClick={() => onAddNode('trigger', item)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', background: 'rgba(255,255,255,0.05)', border: 'none', borderRadius: '4px', color: '#ccc', cursor: 'pointer', fontSize: '11px', textAlign: 'left', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'} onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}>
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div>
                <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#ec4899', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Etapas</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {FLOW_MENU_ITEMS.etapa.map(item => (
                        <button key={item.id} onClick={() => onAddNode('etapa', item)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', background: 'rgba(236, 72, 153, 0.1)', border: '1px solid rgba(236, 72, 153, 0.2)', borderRadius: '4px', color: '#fbcfe8', cursor: 'pointer', fontSize: '11px', textAlign: 'left', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = 'rgba(236, 72, 153, 0.2)'} onMouseOut={e => e.currentTarget.style.background = 'rgba(236, 72, 153, 0.1)'}>
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div>
                <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#eab308', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Texto</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {FLOW_MENU_ITEMS.texto.map(item => (
                        <button key={item.id} onClick={() => onAddNode('texto', item)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', background: 'rgba(234, 179, 8, 0.1)', border: '1px solid rgba(234, 179, 8, 0.2)', borderRadius: '4px', color: '#fef08a', cursor: 'pointer', fontSize: '11px', textAlign: 'left', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = 'rgba(234, 179, 8, 0.2)'} onMouseOut={e => e.currentTarget.style.background = 'rgba(234, 179, 8, 0.1)'}>
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div>
                <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#3b82f6', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Formas</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {FLOW_MENU_ITEMS.formas.map(item => (
                        <button key={item.id} onClick={() => onAddNode('formas', item)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 8px', background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '4px', color: '#93c5fd', cursor: 'pointer', fontSize: '11px', textAlign: 'left', transition: 'background 0.2s' }} onMouseOver={e => e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)'} onMouseOut={e => e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)'}>
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}
